module.exports = __webpack_public_path__ + "static/media/envelope.a0350bbb.svg";